import React from 'react';

import { Nullable } from '@clearverify/types';

import {
  PeoPayrollProviderStaffsListDocument,
  useSendInvitesToPeoPayrollProviderStaffByCvStaffMutation,
} from 'src/api';
import { useNotification } from 'src/hooks/app';

import { InvitePeoPayrollProviderStaffForm } from './InvitePeoPayrollProviderStaffForm';
import { InviteFormFieldsValues } from './types';

export type InvitePeoPayrollProviderStaffByCVStaffModalFormProps = {
  peoPayrollProviderId: Nullable<string>;
  onCloseModal: () => void;
  switchClosability: (status: boolean) => void;
};

export const InvitePeoPayrollProviderStaffByCVStaffModalForm: React.FC<
  InvitePeoPayrollProviderStaffByCVStaffModalFormProps
> = ({ peoPayrollProviderId, onCloseModal, switchClosability }) => {
  const { createApolloContext } = useNotification();

  const [sendInvites] = useSendInvitesToPeoPayrollProviderStaffByCvStaffMutation({
    refetchQueries: [PeoPayrollProviderStaffsListDocument],
    awaitRefetchQueries: true,
    context: createApolloContext({
      successMessage: 'Invites to Peo Payroll Providers successfully sent',
    }),
  });

  const handleSubmit = React.useCallback(
    async (formFields: InviteFormFieldsValues) => {
      switchClosability(false);

      try {
        await sendInvites({
          variables: {
            peoPayrollProviderId: peoPayrollProviderId ?? '',
            staff: formFields.staff,
          },
        });

        switchClosability(true);
        onCloseModal();
      } catch (error) {
        console.error(error);
        switchClosability(true);
      }
    },
    [switchClosability, sendInvites, peoPayrollProviderId, onCloseModal],
  );

  return <InvitePeoPayrollProviderStaffForm onCloseModal={onCloseModal} onSubmit={handleSubmit} />;
};
